.price-list-quantity-selector {
  display: flex;
  flex-direction: column;
}
.price-list-quantity-selector .price-quantity-selector {
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-bottom: 10px;
}
.price-list-quantity-selector .price-quantity-selector.disabled .info, .price-list-quantity-selector .price-quantity-selector.disabled .price, .price-list-quantity-selector .price-quantity-selector.disabled .warnings > :not(.kind-error) {
  text-decoration: line-through 2px;
}
.price-list-quantity-selector .price-quantity-selector .info {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  font-weight: 700;
  font-size: 18px;
}
.price-list-quantity-selector .price-quantity-selector .qty-selector {
  display: flex;
  flex: 1;
  justify-content: end;
  margin-top: 10px;
}
.price-list-quantity-selector .price-quantity-selector .qty-selector > .number-spinner {
  width: 33%;
}
.price-list-quantity-selector .invalid-qty {
  display: flex;
  justify-content: end;
  font-weight: 700;
  font-size: 18px;
  margin: 10px 0;
}
.price-list-quantity-selector .actions {
  display: flex;
  justify-content: end;
}
.price-list-quantity-selector .actions .btn-primary {
  margin-left: 10px;
  flex: 2;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */